<template>
    <div class="flex-root-column replacements">
        <ReplacementsStandard
            v-if="currentReplacementType === 'standard'"
            :view-mode="viewMode"
            @showMessage="showMessage"
        />
        <ReplacementsMars
            v-if="currentReplacementType === 'mars'"
            :view-mode="viewMode"
            @showMessage="showMessage"
        />
        <ReplacementsMerc
            v-if="currentReplacementType === 'merc'"
            :view-mode="viewMode"
            @showMessage="showMessage"
        />
        <v-snackbar
            v-model="messageBox.show"
            :timeout="messageBox.closeTimeout"
            light
            class="coa_snack"
            :class="'coa_' + messageBox.type"
        >
            {{ messageBox.content }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    v-show="messageBox.closeTimeout === 0"
                    v-bind="attrs"
                    @click="messageBox.show = false"
                >
                    {{ messageBox.closeButtonText }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import ReplacementsStandard from "../components/Replacements/Standard/ReplacementsStandard";
import ReplacementsMars from "../components/Replacements/Mars/ReplacementsMars";
import ReplacementsMerc from "../components/Replacements/Merc/ReplacementsMerc";

export default {
    name: 'Replacements',
    components: {ReplacementsStandard, ReplacementsMars, ReplacementsMerc},
    created() {
        this.$emit('updateHeaderNavigation', []);
        this.$emit('updateHeaderTabBar', {
            tabs: [
                {
                    id: 'standard',
                    name: '<span class="bold">Standard</span> CEDEX Replacements'
                }, {
                    id: 'mars',
                    name: '<span class="bold">MARS</span> CEDEX Replacements'
                }, {
                    id: 'merc',
                    name: '<span class="bold">MERC+</span> CEDEX Replacements'
                },
            ],
            active: this.currentReplacementType,
            showClose: true
        });
    },
    data() {
        return {
            currentReplacementType: this.$getExternalValue('replacementType', 'merc'),
            messageBox: {
                show:            false,
                content:         '',
                closeButtonText: 'ok',
                closeTimeout:    -1,
            },
        }
    },
    props: {
        viewMode: {
            type: String,
            default: 'default'
        }
    },
    methods: {
        showMessage(content, type, close, buttonText) {
            this.messageBox.content = content;
            this.messageBox.type = type;
            this.messageBox.show = true;
            if (typeof close === 'number') {
                this.messageBox.closeTimeout = close;
            } else {
                this.messageBox.closeTimeout = -1;
            }
            if (buttonText) {
                this.messageBox.closeButtonText = buttonText;
            } else {
                this.messageBox.closeButtonText = 'ok';
            }
        }
    }
}
</script>